// Create a global event bus
// See: https://www.digitalocean.com/community/tutorials/vuejs-global-event-bus
import Vue from 'vue'
export const EventBus = new Vue()
